<script setup lang="ts">
import { ref } from "vue";
import { useTranslation } from "i18next-vue";
import DraggerMenuState from "@/stores/DraggerMenuState";
import SettingsOptionItem from "./SettingsOptionItem.vue";
import CanvasBusyOverlay from "@/components/canvas/CanvasBusyOverlay.vue";

const { t } = useTranslation();
const isLoading = ref(false);
const loadingStatus = ref("");

async function toggleLineWeight() {
  isLoading.value = true;
  loadingStatus.value = t(
    DraggerMenuState.isLwActive
      ? "canvas:settings.lineWeight.deactivating"
      : "canvas:settings.lineWeight.activating",
  );
  await new Promise((resolve) => setTimeout(resolve, 100));
  DraggerMenuState.toggleLineWeight();
  isLoading.value = false;
}
</script>

<template>
  <SettingsOptionItem
    :title="$t('canvas:settings.lineWeight.option.type.title')"
    :description="$t('canvas:settings.lineWeight.option.type.desc')"
    :icon="DraggerMenuState.isLwActive ? 'pause-fill' : 'pause'"
    @click="toggleLineWeight()"
  />
  <!-- Fullscreen loading overlay - direct render, no teleport -->
  <CanvasBusyOverlay v-if="isLoading" :status="loadingStatus" />
</template>
